import React from 'react';
import { CssStyleProps } from 'src/base/props/CssStyleProps';
import { Text } from 'src/base/texts/Text';

export const H3: React.FC<CssStyleProps> = ({ children, className, style }) => (
  <Text variant="h3" style={style} className={className}>
    {children}
  </Text>
);
